import React, { useEffect, useRef, useState } from 'react';
import { Select, Button } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { AVApi, useVideoController } from '../controller/video/VideoControlContext';
import AudioStreamVisualizer from './AudioStreamVisualizer';
const { Option } = Select;

const VIDEO_DIMENSIONS = 280;

const SelectAV = ({ onComplete = () => {} }: { onComplete?: () => any }) => {
  const {
    localVideoTrack,
    localAudioTrack,
    setHasAVBeenSet,
    audioDevices,
    videoDevices,
    setLocalAudio,
    setLocalVideo,
    setAudioInputBlocked,
    setLocalVideoEnabled,
    isAudioInputBlocked,
    localVideoEnabled,
    avPermission,
  } = useVideoController();
  const videoRef = useRef<HTMLVideoElement>(null);

  const [step, setStep] = useState<'audio' | 'video'>('video');

  // disabled due to blocking the main thread for 8 seconds...
  // function handleCanPlay() {
  //   videoRef?.current?.play();
  // }
  useEffect(() => {
    if (!localVideoEnabled) {
      setLocalVideoEnabled(true);
    }
  }, [setLocalVideoEnabled, localVideoEnabled]);

  useEffect(() => {
    if (isAudioInputBlocked) {
      setAudioInputBlocked(false);
    }
  }, [setAudioInputBlocked, isAudioInputBlocked]);

  useEffect(() => {
    if (videoRef.current && localVideoTrack) {
      videoRef.current.srcObject = new MediaStream([localVideoTrack]);
    }
  }, [localVideoTrack, videoRef]);

  return (
    <>
      {avPermission === 'denied' ? (
        <div style={{ width: 500, fontSize: 20 }}>
          <div>
            Please enable webcam and microphone access to use audio and video features.
            <br />
            <br />
            Look for an icon near your browser's address bar.
          </div>
          <div
            className='onboarding-actions-group'
            style={{ justifyContent: 'flex-end', marginTop: 40 }}>
            {/* <Button
                  style={{ width: '48%', height: 80 }}
                  size='large'
                  type='dashed'
                  onClick={() => {
                    onComplete();
                  }}>
                  cancel
                </Button> */}
            <Button
              style={{ width: '48%', height: 80 }}
              size='large'
              type='primary'
              onClick={() => {
                onComplete();
              }}>
              ok
            </Button>
          </div>
        </div>
      ) : (
        <>
          {step === 'audio' && (
            <>
              <label htmlFor='audio'>Audio</label>
              <Select
                style={{ width: '100%' }}
                placeholder='Select audio input'
                onSelect={(__, option) => {
                  setLocalAudio(String(option.key));
                }}
                value={AVApi.getStreamAudioDeviceId(localAudioTrack)}>
                {audioDevices.map((device: OT.Device) => (
                  <Option key={device.deviceId} value={device.deviceId}>
                    <div style={{ color: 'black' }}>{device.label}</div>
                  </Option>
                ))}
              </Select>
              <div className='onboarding-actions-group'>
                <AudioStreamVisualizer />
              </div>
              <div className='onboarding-actions-group'>
                <Button
                  style={{ width: '48%', height: 80 }}
                  size='large'
                  type='dashed'
                  onClick={() => {
                    onComplete();
                  }}>
                  cancel
                </Button>
                <Button
                  style={{ width: '48%', height: 80 }}
                  size='large'
                  type='primary'
                  onClick={() => {
                    setHasAVBeenSet(true);
                    onComplete();
                  }}>
                  next
                </Button>
              </div>
            </>
          )}
          {step === 'video' && (
            <>
              <Select
                style={{ width: '100%' }}
                placeholder='Select video input'
                onSelect={(value, option) => {
                  setLocalVideo(String(option.key));
                }}
                value={AVApi.getStreamVideoDeviceId(localVideoTrack)}>
                {videoDevices.map((device: OT.Device) => (
                  <Option key={device.deviceId} value={device.deviceId}>
                    <div style={{ color: 'black' }}>{device.label}</div>
                  </Option>
                ))}
              </Select>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  paddingTop: 40,
                  paddingBottom: 30,
                }}>
                <CameraOutlined style={{ fontSize: VIDEO_DIMENSIONS / 2, position: 'absolute' }} />
                <video
                  width={VIDEO_DIMENSIONS}
                  height={VIDEO_DIMENSIONS}
                  id='localVideo'
                  ref={videoRef}
                  // onCanPlay={handleCanPlay}
                  autoPlay
                  playsInline
                  muted
                  style={{ transform: 'rotateY(180deg)', borderRadius: '50%', objectFit: 'cover' }}
                />
              </div>
              <div className='onboarding-actions-group'>
                <Button
                  style={{ width: '48%', height: 80 }}
                  size='large'
                  type='dashed'
                  onClick={() => {
                    onComplete();
                  }}>
                  cancel
                </Button>
                <Button
                  style={{ width: '48%', height: 80 }}
                  size='large'
                  type='primary'
                  onClick={() => {
                    setStep('audio');
                  }}>
                  next
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default SelectAV;
